import React, { useState } from 'react';
import { Header, Form, Input } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

const DATE_RANGE_OPTIONS = {
  AVAILABLE_DAYS: 'AvailableDays',
  DATE_RANGE: 'DateRange',
};

const DateRangeSelector = ({ dateRange, updateDateRange }) => {
  const [startDate, endDate] = dateRange;
  return (
    <Form.Field>
      <DatePicker
        selectsRange
        minDate={new Date()}
        startDate={startDate ? new Date(startDate) : null}
        endDate={endDate ? new Date(endDate) : null}
        onChange={updateDateRange}
        dateFormat="MMMM d, yyyy"
      />
    </Form.Field>
  );
};

const DateRange = ({ project, settings, setSettings }) => {
  const [rangeType, setRangeType] = useState(
    settings.startDate && settings.endDate
      ? DATE_RANGE_OPTIONS.DATE_RANGE
      : DATE_RANGE_OPTIONS.AVAILABLE_DAYS,
  );
  const [dateRange, setDateRange] = useState([settings.startDate, settings.endDate]);
  const noExternalAccounts = project.owners.every(
    (owner) => {
      if (!owner.externalAccountStatuses) return true;
      return owner.externalAccountStatuses.length === 0 || owner.externalAccountStatuses.every((account) => account.status === 'error');
    },
  );
  return (
    <div className="additional-setting">
      <Header>
        Date range
        <Header.Subheader>
          Experts can schedule...
        </Header.Subheader>
      </Header>
      {noExternalAccounts && (
        <>
          <Header as="h5">
            Can&apos;t connect your calendar? Set the date range below to 1
            week only and update your Daily Time Blocks to match the upcoming
            week&apos;s availability.
          </Header>
          <Header as="h5" style={{ marginTop: 0 }}>
            You&apos;ll need to update both again at the start of next week to
            show the open time slots to experts.
          </Header>
        </>
      )}
      <div className="available-days-option">
        <Form.Radio
          checked={rangeType === DATE_RANGE_OPTIONS.AVAILABLE_DAYS}
          onChange={(e, { checked }) => {
            if (checked) {
              setRangeType(DATE_RANGE_OPTIONS.AVAILABLE_DAYS);
              setSettings({ ...settings, startDate: null, endDate: null });
            }
          }}
        />
        <div className="option-label">
          <Input
            size="small"
            type="number"
            min={0}
            value={settings.availableDays}
            onChange={(e, { value }) => setSettings({ ...settings, availableDays: value })}
          />
          {' calendar days into the future.'}
        </div>
      </div>
      <div className="date-range-option">
        <Form.Radio
          checked={rangeType === DATE_RANGE_OPTIONS.DATE_RANGE}
          label="Within a date range"
          onChange={(e, { checked }) => {
            if (checked) {
              setRangeType(DATE_RANGE_OPTIONS.DATE_RANGE);
              setSettings({ ...settings, startDate: dateRange[0], endDate: dateRange[1] });
            }
          }}
        />
        {rangeType === DATE_RANGE_OPTIONS.DATE_RANGE && (
          <DateRangeSelector
            dateRange={dateRange}
            updateDateRange={(dates) => {
              const startDate = dates[0] ? moment(dates[0]).format('YYYY/MM/DD') : null;
              const endDate = dates[1] ? moment(dates[1]).format('YYYY/MM/DD') : null;
              setDateRange([startDate, endDate]);
              setSettings({ ...settings, startDate, endDate });
            }}
          />
        )}
      </div>
    </div>
  );
};

export default DateRange;
